import SyncAddresses from "../features/sync-addresses/syncAddresses";

export default function SyncAddressesPage(){
    return <SyncAddresses/>;
}